import React from 'react';
import Breadcrumb from '../../breadcrumb/component.tsx';
import type { BreadcrumbData } from '../../types.tsx';
import { createBoardUrl } from '../common/create-url/index.tsx';
import type { BoardBreadcrumbProps } from './types.tsx';

const BoardBreadcrumb = ({
	children,
	boardId,
	boardName,
	isSimplifiedProject,
	projectId,
}: BoardBreadcrumbProps) => {
	const breadcrumb: BreadcrumbData = {
		href: createBoardUrl(boardId),
		text: boardName,
		type: 'boardName',
		analyticsAttributes: {
			nextGenProject: isSimplifiedProject,
			projectConfig:
				isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic',
		},
		analyticsFields: {
			name: 'navigateToSubProject',
			containerId: projectId,
			containerType: 'project',
		},
	};

	return <Breadcrumb breadcrumb={breadcrumb}>{children}</Breadcrumb>;
};

BoardBreadcrumb.defaultProps = {
	children: null,
	isSimplifiedProject: false,
	projectId: undefined,
};

export default BoardBreadcrumb;
